import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetSettingsCompleteResponse extends BackendResponse {
  item: CvpSettingsFromServer;
}

export interface GetSettingsCompleteParameters extends NextApiParams {
  idEmbed: string | null;
}

export const getSettingsComplete = withNextApi<
  GetSettingsCompleteResponse,
  GetSettingsCompleteParameters
>("/CvpSettings/CvpGetSettingsComplete", { method: "GET" });

export interface CvpSettingsFromServer {
  [key: string]: SettingDefinition;
}

export interface SettingDefinition {
  type: "string" | "boolean";
  defaultvalue: string | boolean | null;
  value: string | boolean | null;
}
